<template>
  <div v-if="loadSnigelDiv">
    <component is="script" data-cfasync="false" type="text/javascript"> var snigelPubConf = { adengine: { activeAdUnits: [], }, }; </component>

    <component is="script" async="" data-cfasync="false" :src="adScriptUrl" type="text/javascript"> </component>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, computed, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import { axiosClassic } from '@/services/axiosConfig';
import { useUserDataStore } from '@/store/userDataStore';
import { getEmbededJson } from '@/services/classic/embededJsonService';

const userDataStore = useUserDataStore();
const route = useRoute(); // Vue router route object
const loadSnigelDiv = ref(false); // Load the snigel div only when the page is loaded
const adScriptUrl = import.meta.env.VITE_AD_SCRIPT_URL; // Import the ad script url from the global variables

const jsdefs = computed(() => {
  return userDataStore.jsdefs;
}); // jsdefs object

document.addEventListener('body_content_loaded', function () {
  if (jsdefs.value) {
    doSnigelAdAuction();
  }

    //if route contains register_thanks, track user creation
    if (route.fullPath.includes('register_thanks') || route.fullPath.includes('register_verify')) {
      TrackTrialStart();
    }

    if (route.fullPath.includes('subscribe_thanks')) {
      TrackTrialConversion();
    }
});

watch(
  () => route.fullPath,
  () => {
    doSnigelAdAuction();
    sendpageview();
  },
);

watch(
  () => jsdefs.value,
  () => {
    userAdConsent();

    if (jsdefs.value) {
      doSnigelAdAuction();
    }
  },
);

onMounted(() => {
  loadSnigelDiv.value = true;
  sendpageview();
});

function sendpageview() {
  (window as any).datahappy.trackPageview();
}

// Load snigel with ad units from jsdefs
function doSnigelAdAuction() {
  var activeAdUnits = jsdefs.value.adUnits; // as an array

  //check activeadunits is not empty and is an array
  if (!Array.isArray(activeAdUnits) || activeAdUnits.length === 0) {
    return;
  }

  var no_ad_pages = jsdefs.value.noAdPages; // as an array
  if (no_ad_pages && no_ad_pages.some((x: string) => route.fullPath.includes(x))) {
    return;
  }

  if ((window as any).adngin && (window as any).adngin.adnginLoaderReady) {
    // when adnginLoaderReady boolean is true, it is safe to access command queues like adngin.queue or googletag.queue
    (window as any).adngin.queue.push(() => {
      // it is recommended to auction only ONCE, so please gather all required ad unit names;
      // or do not pass anything if all ad units are to be re-auctioned
      (window as any).adngin.cmd.startAuction(activeAdUnits);
      console.log('Snigel ad auction started');
      console.log(activeAdUnits);
    });
  }
}


function userAdConsent() {
  try {
    window.addEventListener('adconsentReady', function () {
      (window as any).adconsent?.('getConsent', null, function (consent: { fullConsent: any }, success: any) {
        if (success) {
          if (consent.fullConsent) {
          } else {
            // User denied consent
          }

          // Update user config if consent has changed
          if (consent.fullConsent != jsdefs.value.userAdconsent) {
            updateAdconsent(jsdefs.value.personId, consent.fullConsent);
          }
        }
      });
    });
  } catch (error) {
    console.log(error);
  }
}

function updateAdconsent(personID: string, consent: string) {
  axiosClassic
    .get('config?action=update_config&type=adverts&personid=' + personID + '&adconsent=' + consent + '&key=' + jsdefs.value.commsKey)
    .then((response) => {
      // console.log(response);
    })
    .catch((error) => {
      console.log(error);
    });
}

function TrackTrialStart() {

  let data = getEmbededJson('registration');

  if (data.registration_data == null || data.registration_data == undefined) {
    return;
  }

  let registationData = data.registration_data;

  const datahappy = (window as any).datahappy;

  let eventProperties: {
    value: any;
    currency: any;
    tax: any;
    items: {
      item_id: any;
      item_name: any;
      price: any;
      quantity: number;
    }[];
    subscription_id?: any; 
    transaction_id?: any; 
  } = {
    value: registationData?.price,
    currency: registationData?.currency,
    tax: registationData?.tax,
    items: [
      {
        item_id : registationData?.item_id,
        item_name : registationData?.item_name,
        price : registationData?.price,
        quantity : 1,
      }
    ],
  }

  if (registationData?.transaction_id) {
    eventProperties.transaction_id = registationData?.transaction_id; 
  }
  if (registationData?.subscription_id) {
    eventProperties.subscription_id = registationData?.subscription_id;
  }

  datahappy.trackTrialStart({
  userId: registationData.personId,
  eventProperties: eventProperties,
  userTraits: {
    email: registationData?.email,
    firstName: registationData?.first_name,
    lastName:   registationData?.last_name,
		createdAt: (new  Date()).toISOString(),
  },
})
}

function TrackTrialConversion() {

  let data = getEmbededJson('subscription');

  if (data == null || data == undefined) {
    return;
  }

  let subscriptionData = data.subscription_data;

  if (subscriptionData == null || subscriptionData == undefined) {
    return;
  }

  let eventProperties: {
    value: any;
    currency: any;
    tax: any;
    items: {
      item_id: any;
      item_name: any;
      price: any;
      quantity: number;
    }[];
    subscription_id?: any; 
    transaction_id?: any; 
  } = {
    value: subscriptionData?.value,
    currency: subscriptionData?.currency,
    tax: subscriptionData?.tax,
    items: [
      {
        item_id : subscriptionData?.item_id,
        item_name : subscriptionData?.item_name,
        price : subscriptionData?.value,
        quantity : 1,
      }
    ],
  }

  if (subscriptionData?.transaction_id) {
    eventProperties.transaction_id = subscriptionData?.transaction_id; 
  }

  if (subscriptionData?.subscription_id) {
    eventProperties.subscription_id = subscriptionData?.subscription_id;
  }

  const datahappy = (window as any).datahappy;
  datahappy.trackEvent({
  userId: subscriptionData?.personId,
  eventName: "trial_conversion",
  eventProperties: eventProperties,})

}


</script>

<style lang="scss"></style>
